export function isUJSXObject(obj) {
    return (obj &&
        typeof obj == 'object' &&
        typeof obj.tag == 'string' &&
        typeof obj.attributes == 'object' &&
        Array.isArray(obj.children));
}
export function createUJSXObject(tag, attributes, ...children) {
    const attrs = {};
    if (attributes)
        for (let rkey in attributes) {
            let key = rkey.toLowerCase();
            if (key == 'classname')
                key = 'class';
            if (key == 'htmlfor')
                key = 'for';
            attrs[key] = attributes[rkey];
        }
    return {
        tag: tag.toLowerCase(),
        attributes: attrs,
        children
    };
}
//# sourceMappingURL=object.mjs.map